import styled from 'styled-components'

const StyledArticle = styled.article`
  position: relative;
  max-width: 800px;
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 30px 0;

  @media screen and (min-width: 769px) {
    flex: 1;
    overflow: hidden;
  }

  .actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 24px;


    .backButton {
      width: 20px;
      height: 20px;
      display: block;
      cursor: pointer;
    }

    .reservation-actions {
      display: flex;
      flex-direction: row;
    }

    button {
      width: 120px;
      margin-left: 10px;
      height: 34px;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 17px;
      background-color: transparent;

      &:not(:last-of-type) {
        border-color: #4A4A4A;
        color: #4A4A4A;
      }

      &:last-of-type {
        border-color: ${ ({ theme }) => theme.colors.red };
        color: ${ ({ theme }) => theme.colors.red };
      }
    }
  }

  > .details-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: ${ ({ theme }) => theme.colors.white };
    box-sizing: border-box;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    padding: 16px 20px;
    overflow: hidden;

    @media screen and (min-width: 769px) {
      overflow-y: auto;

      > section:first-child {
        flex: 1 0 auto;
        height: auto;
      }
    }

    .map-container {
      overflow: hidden;

      > .map {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
      }
    }

    .details {
      flex: 1;
    }

    footer {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 8px;

      button {
        max-width: 30%;
        min-width: 0;
        height: auto;
        min-height: 44px;
        padding: 8px 12px;
        overflow-wrap: anywhere;
        text-align: center;

        @media screen and (max-width: 768px) {
          flex: 1 1 120px;
          max-width: none;
        }
      }
    }
  }

  .info-bubble {
    position: absolute;
    top: 106px;
    left: 36px;
    display: flex;
    align-items: center;
    gap: 8px;
    background-color:  ${ ({ theme }) => theme.colors.accentDark };
    color: white;
    padding: 8px;
    border-radius: 10px;
    mix-blend-mode: hard-light;

    img {
      width: 20px;
      height: 20px;
      filter: invert(1);
    }

    span {
      font-weight: bold;
    }
  }

  @media screen and (max-width: 768px) {
    height: auto;
  }
`

const StyledModalDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  header {
    h3 {
      margin: 0 !important;
    }

    img {
      cursor: pointer;
    }
  }

  section {
    gap: 24px !important;

    .cancellation-reason {
      display: flex;
      flex-direction: column;
      gap: 6px;

      label {
        font-size: 14px;
        color: ${ ({ theme }) => theme.colors.greyDark };
      }

      textarea {
        font-family: inherit;
        font-size: 15px;
        padding: 10px 12px;
        border-radius: 8px;
        border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
        resize: vertical;

        &:focus {
          outline: none;
          border-color: ${ ({ theme }) => theme.colors.primary };
        }
      }

      /* the shared Select caps itself at 100px, too narrow for these labels */
      .select-container {
        width: 100%;
        max-width: none;
      }
    }

    .refund-container {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .link {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
        color: ${ ({ theme }) => theme.colors.accent };
        text-decoration: underline;
      }

      .externalLink {
        width: 12px;
        height: 12px;
        filter: brightness(0) saturate(100%) invert(28%) sepia(45%) saturate(4387%) hue-rotate(255deg) brightness(86%) contrast(101%);
      }
    }
  }

  footer {
    margin-top: 8px !important;
  }
`

export { StyledArticle, StyledModalDiv }
